import StripedTableCell from '../../StripedTable/StripedTableCell';
import StripedTableScrollbarRow from '../../StripedTable/StripedTableScrollbarRow';
import IconDelete from '../../svg/IconDelete';
import React from 'react';
import moment from 'moment';
import Flex from '../../containers/Flex';

const EventCalendarTableRow = ({
    columnDefinitions,
    data,
    index,
    scrollPx,
    onScroll,
    gutterOffsetTop,
    maxHeight,
    border,
    active = false,
    scrollableLength,
    onHover,
    isHighlighted = false,
    isNextRowActive,
    noOfRows = 0,
    onDeleteClick,
    id,
    readOnly = false,
    dateFormat
}) => {
    const cellStyle = {
        height: 50,
        padding: '0 8px',
        fontFamily: 'roboto',
        fontSize: 18,
        color: 'rgb(65,65,65)',
        fontWeight: 500
    };

    const activeBorder = '1px solid #FD9A00';

    const spanTableCell = (type, d, i, array) => {
        switch (type) {
            case 'date':
                return (
                    <StripedTableCell
                        border={border}
                        index={index}
                        id={`table-cell-${id}-${i}`}
                        key={`cell${i}`}
                        align='right'
                        style={{
                            ...cellStyle,
                            paddingRight: 20,
                            borderLeft:
                                i === 0 ? (active ? activeBorder : border) : '',
                            borderRight:
                                active && i === array.length - 1
                                    ? activeBorder
                                    : border,
                            borderBottom:
                                active || isNextRowActive
                                    ? activeBorder
                                    : border,
                            cursor: isHighlighted ? 'pointer' : 'default'
                        }}
                        scrollPx={scrollPx}
                        onHover={onHover}
                        isHighlighted={isHighlighted}
                        evenStyle={{ backgroundColor: '#FFFBEA' }}
                        oddStyle={{ backgroundColor: '#FFFDF4' }}
                    >
                        {moment(data[d.field]).format(dateFormat)}
                    </StripedTableCell>
                );

            case 'text':
                return (
                    <StripedTableCell
                        border={border}
                        index={index}
                        id={`table-cell-${id}-${i}`}
                        key={`cell${i}`}
                        style={{
                            ...cellStyle,
                            paddingLeft: 20,
                            borderLeft:
                                i === 1 ? (active ? activeBorder : border) : '',
                            borderRight:
                                active && i === array.length - 1
                                    ? activeBorder
                                    : border,
                            borderBottom:
                                active || isNextRowActive
                                    ? activeBorder
                                    : border,
                            cursor: isHighlighted ? 'pointer' : 'default'
                        }}
                        scrollPx={scrollPx}
                        onHover={onHover}
                        isHighlighted={isHighlighted}
                        evenStyle={{ backgroundColor: '#FFFBEA' }}
                        oddStyle={{ backgroundColor: '#FFFDF4' }}
                    >
                        {data[d.field].toString()}
                    </StripedTableCell>
                );

            default:
                break;
        }
    };

    return (
        <StripedTableScrollbarRow
            id={`table-row-${id}-${index}`}
            isFirstRow={index === 1}
            scrollPx={scrollPx}
            onScroll={onScroll}
            gutterOffsetTop={gutterOffsetTop}
            maxHeight={maxHeight}
            border={border}
            scrollableHeight={scrollableLength}
            noOfRows={noOfRows}
        >
            <StripedTableCell
                border={border}
                index={index}
                id={`table-cell-${id}-${index}`}
                key={`cell${index}`}
                style={{
                    ...cellStyle,
                    borderLeft: border,
                    borderRight: border,
                    borderBottom:
                        active || isNextRowActive ? activeBorder : border,
                    cursor: isHighlighted ? 'pointer' : 'default',
                    margin: 'auto'
                }}
                scrollPx={scrollPx}
                onHover={onHover}
                isHighlighted={isHighlighted}
                evenStyle={{ backgroundColor: '#FFFBEA' }}
                oddStyle={{ backgroundColor: '#FFFDF4' }}
                onClick={onDeleteClick}
            >
                <Flex centre>
                    <IconDelete
                        size={18}
                        fill={readOnly ? '#989898' : '#414141'}
                        disabled={readOnly}
                    />
                </Flex>
            </StripedTableCell>

            {columnDefinitions.map((d, i, array) => {
                return spanTableCell(d?.type, d, i, array);
            })}
        </StripedTableScrollbarRow>
    );
};

export default EventCalendarTableRow;
